/**
 * @packageDocumentation
 * @module      EmcConsts.ts
 * @description Encapsulates the EMC constansts used in the UI logic.
 * @copyright   Copyright © 2025 Siemens Healthineers. All rights reserved.
 */
class EmcConsts {
}
EmcConsts.MAX_POLL_LIMIT = 3;
EmcConsts.POLLING_INTERVAL = 500;
EmcConsts.REFRESH_INTERVAL = 500;
EmcConsts.ADDITIONAL_WAIT_TIME = 100; // Additional wait time to ensure polling is complete {Used for UT's}
EmcConsts.MAX_LAG_PACKETS_COUNT = 4;
EmcConsts.NOT_AVAILABLE = "Not Available";
export default EmcConsts;
//# sourceMappingURL=EmcConsts.js.map